import '@fontsource-variable/inter';
import { isNil } from 'lodash-es';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'src/ui/index.css';
import 'src/ui/polyfills';

declare global {
  interface Window {
    Keyboard?: { hide: () => void }; // cordova only
    BuildInfo?: { versionCode: string }; // cordova only
  }
}

const GLOBAL_STRICT_MODE = false;

const App = React.lazy(() => import('src/ui/App'));

function renderApp() {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLDivElement
  );

  if (GLOBAL_STRICT_MODE) {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    root.render(<App />);
  }
}

if (!isNil(window.cordova)) {
  document.addEventListener('deviceready', () => renderApp());
} else {
  renderApp();
}
